import script from "./AppStorePwaInstructionsPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStorePwaInstructionsPopup.vue?vue&type=script&setup=true&lang=ts"

import "./AppStorePwaInstructionsPopup.vue?vue&type=style&index=0&id=f9754690&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9754690"]])

export default __exports__